import { render, staticRenderFns } from "./NormalSearchNav231.vue?vue&type=template&id=2b1c4eb4&scoped=true&"
import script from "./NormalSearchNav231.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav231.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1c4eb4",
  null
  
)

export default component.exports